import { Image, Text, View } from '@react-pdf/renderer';
import { S3_URL } from 'constants';
import { checkObjHasValues, convertToPng, formatShortDate } from 'utils';

const Education = ({ styles, data = [], headerTitle, randomString }: any) => {
	return (
		<View style={styles.mainBox}>
			<Text style={styles.heading}>{headerTitle}</Text>

			<View style={styles.mainBoxInner}>
				{data?.map((platform: any, idx: any) => {
					if (checkObjHasValues(platform)) {
						return (
							<View
								key={`${platform?.instituteName}-${platform?.startDate}-${idx}`}
								style={styles.detailBox}
							>
								{platform?.instituteLogo && (
									<View>
										<Image
											style={styles.detailIcon}
											src={convertToPng(`${S3_URL}${platform.instituteLogo}`)}
										/>
									</View>
								)}
								<View>
									<Text style={styles.detailText}>{platform?.degree}</Text>
									<Text
										style={styles.detailSubText}
									>{`${platform?.countryName} | ${formatShortDate(platform?.startDate)} - ${formatShortDate(platform?.endDate)}`}</Text>
								</View>
							</View>
						);
					}
				})}
			</View>
		</View>
	);
};

export default Education;
